export default __webpack_public_path__ + "static/taskdefinition3-ffdd924875a94d4a30b6f151bdf252a6.png";